import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronRightDoubleS2: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.55 8.48l3.53 3.53-3.53 3.53-1.06-1.06 2.47-2.47-2.47-2.47 1.06-1.06zM8.55 8.48l3.53 3.53-3.53 3.53-1.06-1.06 2.47-2.47-2.47-2.47 1.06-1.06z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ChevronRightDoubleS2.displayName = 'ChevronRightDoubleS2';
export default ChevronRightDoubleS2;
